import './InstallExtensionDialog.scss';
import React, { FC } from 'react';
import installExtensionScreen from '../../../../assets/images/admin/install_extension.gif';
import { useExtensionObserver } from '../../../../scripts/hooks/extension';
import { installExtension } from '../../../../scripts/utils';
import { Dialog } from '../../Dialog/Dialog';
import { UIButton } from '../../ui/UIButton/UIButton';

interface InstallChromeExtensionDialogProps {
  open: boolean;
  onClose(): void;
}

export const InstallChromeExtensionDialog: FC<
  InstallChromeExtensionDialogProps
> = ({ open, onClose }) => {
  const extensionInstalled = useExtensionObserver();

  return (
    <Dialog
      className="installExtensionDialog"
      content={
        <div className="flex flex-col items-center gap-8">
          <img src={installExtensionScreen} width={650} />
          <div className="mt-2 flex flex-col items-center gap-4">
            <div className="text-lg">Install Instructions</div>
            <div className="text-2xl font-semibold text-center max-w-sm">
              Click <span className="text-amethys-10">‘Keep it’</span> when
              Chrome shows you the pop-up after you install
            </div>
            <div>
              This will allow Dashworks to activate and complete your
              installation
            </div>
          </div>
          <UIButton
            disabled={extensionInstalled}
            onClick={installExtension}
            size="long"
          >
            Install Extension
          </UIButton>
        </div>
      }
      onClose={onClose}
      open={open}
    />
  );
};
